import utils from '@/util'
import { ACQUISITION_COOKIE, ACQUISITION_FLAG, SIGNAL_TTL_DAYS } from '@/constant/acquisitionSignal.constant'

// Re-exported so existing importers of segment.utils keep working unchanged.
export { ACQUISITION_COOKIE, ACQUISITION_FLAG, SIGNAL_TTL_DAYS }

const TTL_MS = SIGNAL_TTL_DAYS * 24 * 60 * 60 * 1000
const SIGNAL_TYPES = ['page', 'ai-prompt', 'ob-answer']
const MAX_SIGNALS = 5
const MAX_VALUE_LENGTH = 500

export const parseAcquisitionLog = (raw, now = new Date()) => {
  if (!raw) return null
  let parsed
  try {
    parsed = JSON.parse(decodeURIComponent(raw))
  } catch (error) {
    return null
  }
  if (!parsed || parsed.v !== 1 || !Array.isArray(parsed.signals)) return null
  const cutoff = now.getTime() - TTL_MS
  const signals = parsed.signals
    .map((signal) => {
      if (!signal || typeof signal !== 'object') return null
      const at = Date.parse(signal.at)
      if (Number.isNaN(at) || at < cutoff) return null
      if (!SIGNAL_TYPES.includes(signal.t)) return null
      if (typeof signal.v !== 'string') return null
      // Rebuild as a fresh allowlisted literal so attacker-controlled extra
      // keys (including a literal "__proto__" own key from JSON.parse) never
      // survive into the persisted log.
      return { t: signal.t, v: signal.v.slice(0, MAX_VALUE_LENGTH), at: signal.at }
    })
    .filter(Boolean)
    .sort((a, b) => Date.parse(a.at) - Date.parse(b.at))
    .slice(0, MAX_SIGNALS)
  if (!signals.length) return null
  return { v: 1, signals }
}

// Raw document.cookie read on purpose: services/cookie getValue applies the
// eu- region prefix and true/false coercion, but ahaSegment is written
// unprefixed by landing-site GTM.
export const readAcquisitionCookie = (now = new Date()) => parseAcquisitionLog(utils.getCookie(ACQUISITION_COOKIE), now)

export const getAcquisitionLog = (currentUser = null, now = new Date()) => {
  const persisted = currentUser?.personalInformation?.acquisition
  if (persisted && typeof persisted === 'object' && Array.isArray(persisted.signals)) return persisted
  return readAcquisitionCookie(now)
}
